import React from 'react';
import styles from './PromoCard.module.scss';
import { HomePromo } from '../../../../../types/home.types';
import { NavigateToInternalUrl } from '../../../../../utils/api.utils';
import { Routes } from '../../../../../types/constants';

interface PromoCardProps {
    promo: HomePromo;
}

const PromoCard = ({ promo }: PromoCardProps) => {
    const primaryAction = promo.cta[0];

    const handleCardClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (!primaryAction || primaryAction.targetType === 'external') {
            return;
        }

        event.preventDefault();
        NavigateToInternalUrl(primaryAction.target as Routes);
    };

    const content = (
        <>
            <img src={promo.imageUrl} alt={promo.title} className={styles.image} />
            <div className={styles.content}>
                <h3 className={styles.title}>{promo.title}</h3>
                <p className={styles.description}>{promo.description}</p>
                {primaryAction ? <span className={styles.cta}>{primaryAction.label}</span> : null}
            </div>
        </>
    );

    if (!primaryAction) {
        return (
            <article className={styles.card}>
                {content}
            </article>
        );
    }

    return (
        <a
            className={styles.card}
            href={primaryAction.target}
            onClick={handleCardClick}
            target={primaryAction.targetType === 'external' ? '_blank' : undefined}
            rel={primaryAction.targetType === 'external' ? 'noopener noreferrer' : undefined}
        >
            {content}
        </a>
    );
};

export default PromoCard;
